document.addEventListener("DOMContentLoaded", function() {
    const start = document.getElementById('shopify-section-template--23600812392768__image_with_text_overlay_aMqBpL');
    const studio = document.getElementById('shopify-section-template--23749930877248__image_with_text_overlay_LFwrgq');
    const truecare = document.getElementById('shopify-section-template--23600812392768__image_with_text_overlay_Lft9qp');


    if (start) {
        start.addEventListener('click', function() {
            window.location.href = '/blogs/the-hair-blog/find-your-perfect-hair-color/';
        });
    }
    if (studio) {
        studio.addEventListener('click', function() {
            window.location.href = '/products/be-creative-farga-haret-sjalv-med-en-van-2-personer/';
        });
    }
    if (truecare) {
        truecare.addEventListener('click', function() {
            window.location.href = '/collections/true-care/';
        });
    }
});